import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Impressum from './pages/Impressum';
import DSGVO from './pages/DSGVO';
import { CookieManagerProvider } from './components/CookieManager';

const App: React.FC = () => {
  return (
    <Router>
      <CookieManagerProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/dsgvo" element={<DSGVO />} />
          </Routes>
        </Layout>
      </CookieManagerProvider>
    </Router>
  );
};

export default App;
